import ILoadableContext from "../types/interfaces/ILoadableContext";
import { BackendUserInfo } from "../functions/requests/getUserInfo";
import { createContext } from "react";

export interface IUserInfoContext extends ILoadableContext {
  userInfo: BackendUserInfo | null;
}

export const UserInfoContext = createContext<IUserInfoContext>({
  userInfo: null,
  loading: true,
  error: null,
  reload: () => {},
  name: "user info",
}); 